import axiosInstance from '@/core/api'
import {
	GetBatchesRequest,
	GetBatchesResponse,
	GetCouponsRequest,
	GetCouponsResponse,
	CreateBatchRequest,
	CreateBatchResponse,
	UpdateBatchRequest,
	UpdateBatchResponse,
	GetUsageHistoryRequest,
	GetUsageHistoryResponse,
} from '../../type'

export const getBatches = async (request: GetBatchesRequest) => {
	const response = await axiosInstance.get<GetBatchesResponse>(
		'/admin/coupons/batches',
		{
			params: request,
		},
	)
	return response.data
}

export const getCoupons = async (request: GetCouponsRequest) => {
	const response = await axiosInstance.get<GetCouponsResponse>(
		'/admin/coupons/coupons',
		{
			params: request,
		},
	)
	return response.data
}

export const createBatch = async (request: CreateBatchRequest) => {
	const response = await axiosInstance.post<CreateBatchResponse>(
		'/admin/coupons/batches',
		request,
	)
	return response.data
}

export const updateBatch = async (id: string, request: UpdateBatchRequest) => {
	const response = await axiosInstance.patch<UpdateBatchResponse>(
		`/admin/coupons/batches/${id}`,
		request,
	)
	return response.data
}

export const deleteBatch = async (id: string) => {
	const response = await axiosInstance.delete<void>(
		`/admin/coupons/batches/${id}`,
	)
	return response.data
}

export const getUsageHistory = async (request: GetUsageHistoryRequest) => {
	const { couponId, ...params } = request
	const response = await axiosInstance.get<GetUsageHistoryResponse>(
		`/admin/coupons/coupons/${couponId}/usage-history`,
		{
			params,
		},
	)
	return response.data
}

export const getCouponsForBrokeNotification = async () => {
	const response = await axiosInstance.get<GetCouponsResponse>(
		'/admin/coupons/broke-notification',
	)
	return response.data
}
